import React, { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { F0Select } from '@factorialco/f0-react'
import { Input, OneModal } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { useComplaintStatus } from 'modules/complaints/hooks/useComplaintStatus'
import { statusLabel } from 'modules/complaints/lib/utils/complaintStatus'

interface ChangeStatusModalProps {
  isOpen: boolean
  onClose: () => void
  complaint: {
    id: number
    status: string
    identifier: string
  }
}

export const ChangeStatusModal: React.FC<ChangeStatusModalProps> = ({
  isOpen,
  onClose,
  complaint,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>(complaint.status)
  const [isLoading, setIsLoading] = useState(false)

  const { updateComplaintStatus, getStatusOptionsForModal } = useComplaintStatus()

  const handleSave = async () => {
    if (selectedStatus === complaint.status) {
      onClose()
      return
    }

    setIsLoading(true)

    await updateComplaintStatus(complaint.id, selectedStatus)

    onClose()
    setIsLoading(false)
  }

  const statusOptions = getStatusOptionsForModal(complaint.status)

  if (statusOptions.length === 0) {
    return null
  }

  return (
    <OneModal isOpen={isOpen} onClose={onClose}>
      <OneModal.Header title={i18n.t('complaints.overview.change_status')} />
      <OneModal.Content withPadding>
        <Box gap="s12">
          <Text.Normal size="200">
            {i18n.t('complaints.overview.complaint_number', {
              identifier: complaint.identifier,
            })}
          </Text.Normal>

          <Box gap="s12" width="full">
            <Input
              label={i18n.t('complaints.overview.existing_status')}
              value={statusLabel(complaint.status)}
              disabled
            />
            <F0Select
              label={i18n.t('complaints.overview.new_status')}
              value={selectedStatus}
              onChange={(value: string) => setSelectedStatus(value)}
              options={statusOptions}
              placeholder={i18n.t('complaints.overview.select_status')}
            />
          </Box>
        </Box>
      </OneModal.Content>
      <OneModal.Footer>
        <Box flexDirection="row" gap="s2" justifyContent="flexEnd" width="full">
          <F0Button onClick={onClose} label={i18n.t('common.cancel')} variant="outline" />
          <F0Button
            onClick={handleSave}
            disabled={isLoading || selectedStatus === complaint.status}
            loading={isLoading}
            label={isLoading ? i18n.t('common.saving') : i18n.t('common.save')}
          />
        </Box>
      </OneModal.Footer>
    </OneModal>
  )
}
